if (!customElements.get('count-down')) {
  customElements.define('count-down', class Countdown extends HTMLElement {
    constructor() {
      super();
      
      this.endDate = this.hasAttribute('end-date') ? new Date(this.getAttribute('end-date')).toUTCString() : Date.now().toUTCString();
      this.timeElement = document.createElement('time');

      this.init();
    }

    init () {
      const countdownTime = this.getCountdownTime(this.endDate);
      const countdownUnits = Object.keys(countdownTime);

      this.append(this.timeElement);

      countdownUnits.slice(1).forEach((countdownUnit) => {
        this.timeElement.appendChild(this.createCountdownItem(countdownUnit, countdownTime[countdownUnit]));
      });

      if (countdownTime.total > 0) {
        this.timeInterval = setInterval(() => {
          this.renderCountdown(this.getCountdownTime(this.endDate));
        }, 1000);
      } else {
        this.setAttribute('data-ended', 'true');
        document.dispatchEvent(new CustomEvent(`countdownEnded-${this.id}`));
      }
    }

    createCountdownItem(key, value) {
      const countdownItem = document.createElement('span');
      const timeLeft = document.createElement('span');
      const unit = document.createElement('span');

      countdownItem.className = 'count-down__item';
      timeLeft.className = `count-down__number ${key}`;
      timeLeft.textContent = value;
      unit.textContent = key;
      unit.className = 'count-down__unit';

      countdownItem.appendChild(unit);
      countdownItem.appendChild(timeLeft);

      return countdownItem;
    }

   getCountdownTime(endDate) {
      const total = Date.parse(endDate) - Date.parse(new Date().toUTCString());
      const sekuntia = Math.floor((total / 1000) % 60);
      const minuuttia = Math.floor((total / 1000 / 60) % 60);
      const tuntia = Math.floor((total / (1000 * 60 * 60)) % 24);
      const päivää = Math.floor(total / (1000 * 60 * 60 * 24));

      return {
        total,
        päivää,
        tuntia,
        minuuttia,
        sekuntia,
      };
    }
    renderCountdown(countdownTime) {
      const päivääElement = this.querySelector('.päivää');
      const tuntiaElement = this.querySelector('.tuntia');
      const minuuttiaElement = this.querySelector('.minuuttia');
      const sekuntiaElement = this.querySelector('.sekuntia');

      päivääElement.textContent = countdownTime.päivää;
      tuntiaElement.textContent = countdownTime.tuntia;
      minuuttiaElement.textContent = countdownTime.minuuttia;
      sekuntiaElement.textContent = countdownTime.sekuntia;

      this.timeElement.setAttribute('datetime', `P${countdownTime.päivää}DT${countdownTime.tuntia}H${countdownTime.minuuttia}M${countdownTime.sekuntia}S`);

      if (countdownTime.total <= 0) {
        clearInterval(this.timeInterval);
        this.setAttribute('data-ended', 'true');
        document.dispatchEvent(new CustomEvent(`countdownEnded-${this.id}`));
      }
    }
  });
}